/**
 * Service functions for the follow-teams feature, backed by `lib/api.ts`'s
 * `apiFetch`. Like `ApiTokenService.ts`, errors are NOT swallowed -- `apiFetch`
 * throws `ApiError` on a non-ok response (including the 400 cap error and 404
 * unknown-team), and callers (see `lib/followedTeams.ts`) handle that.
 */
import { APP_CONFIG } from 'config/config';
import { apiFetch } from 'lib/api';

// Minimal shape of teams.Team actually used by the follow-teams UI. There's
// no shared `Team` type elsewhere in the app (team pages pass plain `any`
// around), so this stays narrow rather than guessing at the rest of the
// model.
export interface Team {
    id: number;
    name: string;
    nickname?: string;
    slug: string;
    location?: string;
    gender: number | string;
    division: number | string;
    source?: string;
}

export interface FollowedTeam {
    id: number;
    createdAt: string;
    userId: string;
    teamId: number;
    isPrimary: boolean;
    team: Team;
}

const BASE = () => `${APP_CONFIG.apiUrl}/v1/profiles/teams`;

export function fetchFollowedTeams(): Promise<FollowedTeam[]> {
    return apiFetch<FollowedTeam[]>(BASE());
}

export function followTeam(teamId: number, isPrimary?: boolean): Promise<FollowedTeam> {
    const body = isPrimary === undefined ? {} : { isPrimary };
    return apiFetch<FollowedTeam>(`${BASE()}/${teamId}`, {
        method: 'PUT',
        body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/json' }
    });
}

export function unfollowTeam(teamId: number): Promise<void> {
    return apiFetch<void>(`${BASE()}/${teamId}`, { method: 'DELETE' });
}
